import { useTranslation } from 'react-i18next'
import { EXTERNAL_LINKS } from '../../constants'

interface SpeakToExpertButtonProps {
    className?: string
    text?: string
}

const SpeakToExpertButton = ({ className = '', text }: SpeakToExpertButtonProps) => {
    const { t, i18n } = useTranslation('common')

    return (
        <a
            href={EXTERNAL_LINKS.WHATSAPP}
            target="_blank"
            rel="noopener noreferrer"
            className={`inline-flex items-center justify-center bg-[#9B2626] text-white font-semibold rounded-[10px] h-8 px-5 text-xs lg:h-[44px] lg:px-4 lg:text-lg hover:bg-[#7a1e1e] hover:text-white visited:text-white active:text-white focus:text-white transition-colors ${className} w-fit`}
        >
            {text ?? t('cta.speakToExpert')}
        </a>
    )
}

export default SpeakToExpertButton
